var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "var(--icon-stroke-width, 1.2)",
    d: "M17.13 19.057H6.87a.93.93 0 0 1-.35-.067.87.87 0 0 1-.29-.189.787.787 0 0 1-.182-.28.738.738 0 0 1-.045-.326l-.05-8.77a.775.775 0 0 1 .278-.523.91.91 0 0 1 .59-.21H17.14a.91.91 0 0 1 .59.21c.16.137.26.323.277.524l-.01 8.77c.01.11-.006.22-.045.324a.786.786 0 0 1-.183.281.87.87 0 0 1-.29.19.93.93 0 0 1-.348.066Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "var(--icon-stroke-width, 1.2)",
    d: "M15.75 8.69v-.964a3.75 3.75 0 0 0-7.5 0v.965M12 12v2.376"
  })));
};
export default SvgLock;